import { ChangeDetectionStrategy, Component, computed, DestroyRef, inject, signal } from '@angular/core'
import { NavigationEnd, Router, RouterOutlet } from '@angular/router'
import { filter } from 'rxjs'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { AppSignals } from '@appShared/services'
import { SiteFooterComponent } from '@appShared/components/site-footer/site-footer.component'
import { SiteHeaderComponent } from '@appShared/components/site-header/site-header.component'
import { SiteSidebarComponent } from '@appShared/components/site-sidebar/site-sidebar.component'
import { SITE_DIRECTORY_ROUTES } from '@appShared/site-directory.routes'

@Component({
   selector: 'app-shell',
   templateUrl: './shell.component.html',
   changeDetection: ChangeDetectionStrategy.OnPush,
   imports: [RouterOutlet, SiteHeaderComponent, SiteFooterComponent, SiteSidebarComponent]
})
export class ShellComponent {
   title = 'SWFC Learning Customer Service'
   currentYear = new Date().getFullYear()
   user = inject(AppSignals).currentUser

   private _customerServiceLandingUrl = `/${SITE_DIRECTORY_ROUTES.customerService.uri}`
   private _currentUrl = signal<string>('')

   showSidebar = computed<boolean>(() => {
      if (!this.user()) {
         return false
      }

      return true //we may want to hide sidebar for routes in the future
      // Hide sidebar on the customer-service landing route (where AccountSearchComponent is displayed)
      //const url = this._currentUrl().split('?')[0].split('#')[0]
      //return url !== this._customerServiceLandingUrl
   })

   constructor(
      private _router: Router,
      destroyRef: DestroyRef
   ) {
      // Seed _currentUrl so showSidebar() is correct on the very first render
      this._currentUrl.set(this._router.url)

      this._router.events
         .pipe(
            filter(routeEvent => routeEvent instanceof NavigationEnd),
            takeUntilDestroyed(destroyRef)
         )
         .subscribe((navigationEnd: NavigationEnd) => {
            this._currentUrl.set(navigationEnd.urlAfterRedirects || navigationEnd.url)
         })
   }
}
